import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withRouter} from 'react-router-dom';

import HeaderRight from './HeaderRight';
import HeaderLeft from './HeaderLeft';
import HeaderSearch from './HeaderSearch';
class Header extends Component {

    render () {
        const style = {
        background: '#FFFFFF'
    }

    return (
            <header style={style} className="an-header">
                <div className="header-left">
                    <HeaderLeft/>
                </div>
                <div className="header-center">
                    <HeaderSearch />
                </div>
                <div className="header-right">
                    <HeaderRight/>
                </div>
            </header>
        );
    }
}

function mapStateToProps (state) {
    return {
    connectolorHeaderBanner: state.headerBAnnerActiveStyle
    }
}

export default withRouter(connect(mapStateToProps)(Header));



// WEBPACK FOOTER //
// ./src/components/Layout/Header/index.js